import { useQuery } from '@tanstack/react-query'
import { bookmarkApi } from '../../../shared/services/bookmarkApi'
import type {
  BookmarkListResponse,
  BookmarkQuery,
} from '../../../types/bookmark'
import { BOOKMARK_LIST_KEY } from './useBookmarkMutations'

/** 북마크 목록 조회. 필터가 바뀌면 자동으로 다시 조회한다. */
export function useBookmarkedUrls(query: BookmarkQuery) {
  return useQuery<BookmarkListResponse>({
    queryKey: [...BOOKMARK_LIST_KEY, query],
    queryFn: () => bookmarkApi.list(query),
    // 목록은 사용자가 직접 바꾸는 데이터라 배경 폴링 대신
    // 변경 시 무효화로 갱신한다 (불필요한 주기적 요청 제거)
    staleTime: 30_000,
    placeholderData: previous => previous,
  })
}

export default useBookmarkedUrls
